module.exports = "/fonts/fa-solid-900.woff?0be94a07755ba9b88f2ebcac0f23a3da";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-solid-900.woff
// module id = qO8l
// module chunks = 0 1